import React from 'react';

import './ButtonReturn.scss';

const ButtonReturn = props => (
  <button type="button" onClick={props.onClick} className={`button button--return ${props.extraClass ? `${props.extraClass}` : ''}`}>{props.children}</button>
);

export default ButtonReturn;
